import { useEffect, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useQueryString } from "../../../hooks";

const useQuery = () => new URLSearchParams(useLocation().search);

export const navigateToAccountIdPage = (accountId, history, pathname, search = "") => {
  navigateToParameterPage("accountId", accountId, history, pathname, search)
};

const createUpdatedSearch = (search, parameterValue, parameterName, fallbackValue) => {
  const params = new URLSearchParams(search);
  if (parameterValue === undefined) {
    if (fallbackValue === undefined) {
      params.delete(parameterName);
    } else {
      params.set(parameterName, fallbackValue);
    }
  } else {
    params.set(parameterName, parameterValue);
  }
  return params.toString();
};

// search is optional. You must include it if you need to maintain existing query string
// OR if you are using multiple useSearchRouter's
export const navigateToParameterPage = (parameterName, parameterValue, history, pathname, search = "", fallbackValue = undefined) => {
  history.replace({ pathname: pathname, search: createUpdatedSearch(search, parameterValue, parameterName, fallbackValue) });
}

const usePropertyNavigator = (parameterName, parameterValue, fallbackValue) => {
  const history = useHistory();
  const query = useQuery();
  const { pathname, search } = useLocation();
  const queryId = query.get(parameterName);

  useEffect(() => {
    if (parameterValue !== queryId) {
      navigateToParameterPage(parameterName, parameterValue, history, pathname, search, fallbackValue);
    }
  }, [parameterName, parameterValue, queryId, history, pathname, search, fallbackValue]);
};

export const useAccountIdRouter = () => {
  return useSearchRouter("accountId")
}

export const useSearchRouter = (parameterName, initialParameterValue = undefined) => {
  const history = useHistory();
  const { url } = useRouteMatch();
  const { search } = useLocation();
  const queryString = useQueryString();
  const [parameterValue, setParameterValue] = useState(queryString[parameterName] || initialParameterValue);

  usePropertyNavigator(parameterName, parameterValue, initialParameterValue);

  const pageNavigate = (newAccountId) => {
    setParameterValue(newAccountId);
    navigateToParameterPage(parameterName, newAccountId, history, url, search);
  }

  return [parameterValue, pageNavigate]
};